import _definePage_default_0 from '/app/resources/js/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/resources/js/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/app/resources/js/pages/admin/AdminDashboardPage.vue?definePage&vue'
import _definePage_default_4 from '/app/resources/js/pages/admin/AdminListingsPage.vue?definePage&vue'
import _definePage_default_5 from '/app/resources/js/pages/admin/AdminUsersPage.vue?definePage&vue'
import _definePage_default_6 from '/app/resources/js/pages/anaesthetist/[id]/[tab].vue?definePage&vue'
import _definePage_default_7 from '/app/resources/js/pages/anaesthetist/AnaesthetistDashboardPage.vue?definePage&vue'
import _definePage_default_8 from '/app/resources/js/pages/dev/index.vue?definePage&vue'
import _definePage_default_9 from '/app/resources/js/pages/dev/DateTimePickerDemoPage.vue?definePage&vue'
import _definePage_default_10 from '/app/resources/js/pages/dev/ListingFormDetailsParallelDemoPage.vue?definePage&vue'
import _definePage_default_11 from '/app/resources/js/pages/dev/ListingTableBulkActionsDemoPage.vue?definePage&vue'
import _definePage_default_12 from '/app/resources/js/pages/dev/TimeSlotDemoPage.vue?definePage&vue'
import _definePage_default_13 from '/app/resources/js/pages/invitation/accept.vue?definePage&vue'
import _definePage_default_14 from '/app/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_15 from '/app/resources/js/pages/secretary_anesthetist/AnaesthetistsPage.vue?definePage&vue'
import _definePage_default_16 from '/app/resources/js/pages/secretary_anesthetist/CalendarPage.vue?definePage&vue'
import _definePage_default_17 from '/app/resources/js/pages/secretary_anesthetist/ExternalContactsPage.vue?definePage&vue'
import _definePage_default_18 from '/app/resources/js/pages/secretary_anesthetist/ListingsPage.vue?definePage&vue'
import _definePage_default_19 from '/app/resources/js/pages/secretary_anesthetist/ProfilePage.vue?definePage&vue'
import _definePage_default_20 from '/app/resources/js/pages/secretary_anesthetist/SecretaryAnaesthetistDashboardPage.vue?definePage&vue'
import _definePage_default_21 from '/app/resources/js/pages/surgeon/[id]/[tab].vue?definePage&vue'
import _definePage_default_22 from '/app/resources/js/pages/surgeon_secretary/ListingCreatePage.vue?definePage&vue'
import _definePage_default_23 from '/app/resources/js/pages/surgeon_secretary/listings/[id].vue?definePage&vue'
import _definePage_default_24 from '/app/resources/js/pages/surgeon_secretary/ProfilePage.vue?definePage&vue'
import _definePage_default_25 from '/app/resources/js/pages/surgeon_secretary/SurgeonSecretaryDashboardPage.vue?definePage&vue'
import _definePage_default_26 from '/app/resources/js/pages/surgeon_secretary/SurgeonSecretaryRegisterPage.vue?definePage&vue'
import _definePage_default_27 from '/app/resources/js/pages/surgeon_secretary/SurgeonsPage.vue?definePage&vue'
import _definePage_default_28 from '/app/resources/js/pages/users/register-anaesthetist.vue?definePage&vue'
import _definePage_default_29 from '/app/resources/js/pages/users/register-surgeon-secretary.vue?definePage&vue'
import _definePage_default_30 from '/app/resources/js/pages/users/register-thank-you.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/app/resources/js/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/app/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'AdminDashboardPage',
        name: 'admin-admin-dashboard-page',
        component: () => import('/app/resources/js/pages/admin/AdminDashboardPage.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'AdminListingsPage',
        name: 'admin-admin-listings-page',
        component: () => import('/app/resources/js/pages/admin/AdminListingsPage.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
  _mergeRouteRecord(
      {
        path: 'AdminUsersPage',
        name: 'admin-admin-users-page',
        component: () => import('/app/resources/js/pages/admin/AdminUsersPage.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  {
    path: '/anaesthetist',
    /* internal name: 'anaesthetist' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: 'anaesthetist-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'anaesthetist-id-tab',
            component: () => import('/app/resources/js/pages/anaesthetist/[id]/[tab].vue'),
            /* no children */
          },
  _definePage_default_6
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'AnaesthetistDashboardPage',
        name: 'anaesthetist-anaesthetist-dashboard-page',
        component: () => import('/app/resources/js/pages/anaesthetist/AnaesthetistDashboardPage.vue'),
        /* no children */
      },
  _definePage_default_7
  )
    ],
  },
  {
    path: '/dev',
    /* internal name: 'dev' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'dev',
        component: () => import('/app/resources/js/pages/dev/index.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'DateTimePickerDemoPage',
        name: 'dev-date-time-picker-demo-page',
        component: () => import('/app/resources/js/pages/dev/DateTimePickerDemoPage.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'ListingFormDetailsParallelDemoPage',
        name: 'dev-listing-form-details-parallel-demo-page',
        component: () => import('/app/resources/js/pages/dev/ListingFormDetailsParallelDemoPage.vue'),
        /* no children */
      },
  _definePage_default_10
  ),
  _mergeRouteRecord(
      {
        path: 'ListingTableBulkActionsDemoPage',
        name: 'dev-listing-table-bulk-actions-demo-page',
        component: () => import('/app/resources/js/pages/dev/ListingTableBulkActionsDemoPage.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: 'TimeSlotDemoPage',
        name: 'dev-time-slot-demo-page',
        component: () => import('/app/resources/js/pages/dev/TimeSlotDemoPage.vue'),
        /* no children */
      },
  _definePage_default_12
  )
    ],
  },
  {
    path: '/invitation',
    /* internal name: 'invitation' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'accept',
        name: 'invitation-accept',
        component: () => import('/app/resources/js/pages/invitation/accept.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/app/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_14
  ),
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('/app/resources/js/pages/second-page.vue'),
    /* no children */
  },
  {
    path: '/secretary_anesthetist',
    /* internal name: 'secretary-anesthetist' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'AnaesthetistsPage',
        name: 'secretary-anesthetist-anaesthetists-page',
        component: () => import('/app/resources/js/pages/secretary_anesthetist/AnaesthetistsPage.vue'),
        /* no children */
      },
  _definePage_default_15
  ),
  _mergeRouteRecord(
      {
        path: 'CalendarPage',
        name: 'secretary-anesthetist-calendar-page',
        component: () => import('/app/resources/js/pages/secretary_anesthetist/CalendarPage.vue'),
        /* no children */
      },
  _definePage_default_16
  ),
  _mergeRouteRecord(
      {
        path: 'ExternalContactsPage',
        name: 'secretary-anesthetist-external-contacts-page',
        component: () => import('/app/resources/js/pages/secretary_anesthetist/ExternalContactsPage.vue'),
        /* no children */
      },
  _definePage_default_17
  ),
  _mergeRouteRecord(
      {
        path: 'ListingsPage',
        name: 'secretary-anesthetist-listings-page',
        component: () => import('/app/resources/js/pages/secretary_anesthetist/ListingsPage.vue'),
        /* no children */
      },
  _definePage_default_18
  ),
  _mergeRouteRecord(
      {
        path: 'ProfilePage',
        name: 'secretary-anesthetist-profile-page',
        component: () => import('/app/resources/js/pages/secretary_anesthetist/ProfilePage.vue'),
        /* no children */
      },
  _definePage_default_19
  ),
  _mergeRouteRecord(
      {
        path: 'SecretaryAnaesthetistDashboardPage',
        name: 'secretary-anesthetist-secretary-anaesthetist-dashboard-page',
        component: () => import('/app/resources/js/pages/secretary_anesthetist/SecretaryAnaesthetistDashboardPage.vue'),
        /* no children */
      },
  _definePage_default_20
  )
    ],
  },
  {
    path: '/surgeon',
    /* internal name: 'surgeon' */
    /* no component */
    children: [
      {
        path: ':id',
        /* internal name: 'surgeon-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'surgeon-id-tab',
            component: () => import('/app/resources/js/pages/surgeon/[id]/[tab].vue'),
            /* no children */
          },
  _definePage_default_21
  )
        ],
      }
    ],
  },
  {
    path: '/surgeon_secretary',
    /* internal name: 'surgeon-secretary' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'ListingCreatePage',
        name: 'surgeon-secretary-listing-create-page',
        component: () => import('/app/resources/js/pages/surgeon_secretary/ListingCreatePage.vue'),
        /* no children */
      },
  _definePage_default_22
  ),
      {
        path: 'listings',
        /* internal name: 'surgeon-secretary-listings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'surgeon-secretary-listings-id',
            component: () => import('/app/resources/js/pages/surgeon_secretary/listings/[id].vue'),
            /* no children */
          },
  _definePage_default_23
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'ProfilePage',
        name: 'surgeon-secretary-profile-page',
        component: () => import('/app/resources/js/pages/surgeon_secretary/ProfilePage.vue'),
        /* no children */
      },
  _definePage_default_24
  ),
  _mergeRouteRecord(
      {
        path: 'SurgeonSecretaryDashboardPage',
        name: 'surgeon-secretary-surgeon-secretary-dashboard-page',
        component: () => import('/app/resources/js/pages/surgeon_secretary/SurgeonSecretaryDashboardPage.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
  _mergeRouteRecord(
      {
        path: 'SurgeonSecretaryRegisterPage',
        name: 'surgeon-secretary-surgeon-secretary-register-page',
        component: () => import('/app/resources/js/pages/surgeon_secretary/SurgeonSecretaryRegisterPage.vue'),
        /* no children */
      },
  _definePage_default_26
  ),
  _mergeRouteRecord(
      {
        path: 'SurgeonsPage',
        name: 'surgeon-secretary-surgeons-page',
        component: () => import('/app/resources/js/pages/surgeon_secretary/SurgeonsPage.vue'),
        /* no children */
      },
  _definePage_default_27
  )
    ],
  },
  {
    path: '/users',
    /* internal name: 'users' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'register-anaesthetist',
        name: 'users-register-anaesthetist',
        component: () => import('/app/resources/js/pages/users/register-anaesthetist.vue'),
        /* no children */
      },
  _definePage_default_28
  ),
  _mergeRouteRecord(
      {
        path: 'register-surgeon-secretary',
        name: 'users-register-surgeon-secretary',
        component: () => import('/app/resources/js/pages/users/register-surgeon-secretary.vue'),
        /* no children */
      },
  _definePage_default_29
  ),
  _mergeRouteRecord(
      {
        path: 'register-thank-you',
        name: 'users-register-thank-you',
        component: () => import('/app/resources/js/pages/users/register-thank-you.vue'),
        /* no children */
      },
  _definePage_default_30
  )
    ],
  }
]
